// libraries
import React from 'react'
import clsx from 'clsx'
import { useFormContext } from 'react-hook-form'

// utils
import { useAnnounceOwnError } from '/lib/reactutils/utils'

// svg
import { Warning } from '/react4xp/components/Svg/Ux/Ux'

interface RadioGroupProps {
    name: string
    labelledBy: string
    required?: boolean
    className?: string
    children?: React.ReactNode
}

// A radio group answers one question, so the required and invalid states and the
// error message belong to the group rather than to each option. The wrapper has
// to live in here because only a child of Form can read the validation state.
export default function RadioGroup({
    name,
    labelledBy,
    required,
    className,
    children
}: RadioGroupProps) {

    const formContext = useFormContext()
    const errors = formContext ? formContext.formState.errors : {}

    const submitCount = formContext ? formContext.formState.submitCount : 0

    const errorMessage = errors && errors[name]?.message
    const announceError = useAnnounceOwnError(Boolean(errorMessage), submitCount)
    const errorMessageId = `${name}-error-message`

    return (
        <div
            className={className}
            role='radiogroup'
            aria-labelledby={labelledBy}
            aria-required={required || undefined}
            aria-invalid={Boolean(errorMessage)}
            aria-describedby={errorMessage ? errorMessageId : undefined}
        >

            {children}

            {errorMessage && (
                <p
                    id={errorMessageId}
                    role={announceError ? 'alert' : undefined}
                    className={clsx(
                        'form-line__error-message',
                        'form-line__error-message--checkbox',
                        'labels-sm-regular'
                    )}
                >
                    <Warning />
                    {typeof errorMessage === 'string' && errorMessage}
                </p>
            )}

        </div>
    )
}
